(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/services/deposit-service.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/services/deposit-service.js');

'use strict';

const jupiter = svs.core.jupiter;
const logger = svs.accountservicesReact.deposit.logger;
const ELZA_TIMEOUT_MS = 4000;

const getCurrentStatus = async () => {
  try {
    const _await$jupiter$callAs = await jupiter.callAsync({
        method: 'GET',
        path: '/player/3/info?include=currentStatus'
      }),
      response = _await$jupiter$callAs.response;
    return response ? response : {
      currentStatus: []
    };
  } catch (err) {
    logger.warn('Error fetching player info for checking currentStatus for DEPOSITS_SUSPENDED', err);
    return {
      currentStatus: []
    };
  }
};

const getSuspensions = async () => {
  try {
    const _await$jupiter$callAs2 = await jupiter.callAsync({
        method: 'GET',
        path: '/player/1/suspensions'
      }),
      response = _await$jupiter$callAs2.response;
    return response ? response : {
      suspensions: []
    };
  } catch (err) {
    logger.warn('Error fetching player suspensions', err);
    return {
      suspensions: []
    };
  }
};

const getNetLossRestrictions = async () => {
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-care');
  if (useOldJupiterApi) {
    try {
      const _await$jupiter$callAs3 = await jupiter.callAsync({
          method: 'GET',
          path: '/gcs/1/activenetlossrestriction'
        }),
        response = _await$jupiter$callAs3.response;
      return response ? response : null;
    } catch (err) {
      logger.warn('Error getting net loss restrictions', err);
      return null;
    }
  }

  const svsFetch = svs.core.svsFetch.create();
  try {
    const response = await svsFetch('/v1/web/me/rapid-loss/status', {
      method: 'GET',
      timeout: ELZA_TIMEOUT_MS
    });
    if (!response.ok) {
      if ([401, 403].includes(response.status)) {
        window.location.href = '/logga-ut';
        return null;
      }
      logger.warn('Error getting net loss restrictions (Elza)', response.status);
      return null;
    }
    const body = await response.json();
    return body || null;
  } catch (err) {
    logger.warn('Error getting net loss restrictions (Elza)', err);
    return null;
  }
};

const getDepositRestrictions = async () => {
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-care');
  if (useOldJupiterApi) {
    try {
      const _await$jupiter$callAs4 = await jupiter.callAsync({
          method: 'GET',
          path: '/gcs/1/depositdialog'
        }),
        response = _await$jupiter$callAs4.response;
      return response ? response : null;
    } catch (err) {
      logger.warn('Error getting depositdialog for deposit restrictions', err);
      return null;
    }
  }

  const svsFetch = svs.core.svsFetch.create();
  try {
    const response = await svsFetch('/v1/web/me/deposit-dialog', {
      method: 'GET',
      timeout: ELZA_TIMEOUT_MS
    });
    if ([401, 403].includes(response.status)) {
      window.location.href = '/logga-ut';
      return null;
    }
    if (!response.ok) {
      logger.warn('Error getting depositdialog for deposit restrictions (Elza)', response.status);
      return null;
    }
    const body = await response.json();
    return (body === null || body === void 0 ? void 0 : body.data) || body || null;
  } catch (err) {
    logger.warn('Error getting depositdialog for deposit restrictions (Elza)', err);
    return null;
  }
};

const getDayTimeLimit = async () => {
  try {
    const _await$jupiter$callAs5 = await jupiter.callAsync({
        method: 'GET',
        path: "/player/2/daytimelimit"
      }),
      response = _await$jupiter$callAs5.response;
    return response ? response : null;
  } catch (err) {
    logger.warn('Error getting players day time limit', err);
    return null;
  }
};

const putDepositAmount = async depositAmount => {
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-care');
  if (useOldJupiterApi) {
    try {
      const _await$svs$core$jupit = await svs.core.jupiter.callAsync({
          method: 'PUT',
          path: '/gcs/1/remainingdeposits',
          data: {
            remainingDeposits: depositAmount
          }
        }),
        response = _await$svs$core$jupit.response;
      if (response !== null && response !== void 0 && response.error) {
        logger.warn('Error setting remainingdeposits', response === null || response === void 0 ? void 0 : response.error);
      }
      return {
        error: response === null || response === void 0 ? void 0 : response.error
      };
    } catch (err) {
      logger.warn('Error setting remainingdeposits', err);
      return {
        error: err
      };
    }
  }
  const svsFetch = svs.core.svsFetch.create();
  try {
    const response = await svsFetch('/v1/web/me/remaining-deposits', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        remainingDeposits: depositAmount
      }),
      timeout: ELZA_TIMEOUT_MS
    });
    if (!response.ok) {
      if ([401, 403].includes(response.status)) {
        window.location.href = '/logga-ut';
        return {
          error: {
            code: response.status,
            message: response.status === 403 ? 'forbidden' : 'unauthorized'
          }
        };
      }
      const body = await response.json().catch(() => null);
      const errorDetail = (body === null || body === void 0 ? void 0 : body.title) || (body === null || body === void 0 ? void 0 : body.detail) || 'Error setting remainingdeposits';
      logger.warn('Error setting remainingdeposits (Elza)', errorDetail);
      return {
        error: {
          code: Number(body === null || body === void 0 ? void 0 : body.errorCode) || response.status,
          message: errorDetail
        }
      };
    }
    if (response.status === 204) {
      return {
        error: null
      };
    }
    const data = await response.json();
    if (data !== null && data !== void 0 && data.error) {
      logger.warn('Error setting remainingdeposits (Elza)', data === null || data === void 0 ? void 0 : data.error);
    }
    return {
      error: (data === null || data === void 0 ? void 0 : data.error) || null
    };
  } catch (err) {
    logger.warn('Error setting remainingdeposits (Elza)', err);
    return {
      error: err
    };
  }
};
svs.accountservicesReact.deposit.services.depositService = {
  getSuspensions,
  getCurrentStatus,
  getNetLossRestrictions,
  getDepositRestrictions,
  getDayTimeLimit,
  putDepositAmount
};

 })(window);